// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"5de4286b","517":"bee98df0"}[chunkId] + ".chunk.js";
};